/**
 * 利用規約。
 *
 * 本文は運営者が最終的に責任を持つ文書なので、アプリの実装から
 * 自動生成はしない。代わりに、実装と食い違わないよう次の点を明記している。
 *
 *   - 共有リンクを知っている人は誰でも閲覧・編集できる (認証を挟まない設計)
 *   - 金銭のやり取りは扱わない (計算と記録だけ。送金は利用者どうしで行う)
 *   - 無償で提供し、予告なく変更・終了する場合がある
 *
 * 運営者名・問い合わせ先・裁判管轄は記入済み。変更する場合は
 * プライバシーポリシーと docs/legal.md も合わせて直すこと。
 */
import { LegalDocument, LegalSection } from "../components/LegalDocument.js";

export function TermsPage() {
  return (
    <LegalDocument title="利用規約" updatedOn="2026年8月18日">
      <p>
        この利用規約 (以下「本規約」) は、Applest (以下「当方」) が提供する割り勘計算サービス
        「スプリ (Spli)」 (以下「本サービス」) の利用条件を定めるものです。本サービスを利用する方
        (以下「利用者」) は、本規約に同意したうえでご利用ください。
      </p>

      <LegalSection heading="第1条 (適用)">
        <ol>
          <li>本規約は、利用者と当方との間の本サービスの利用に関わる一切の関係に適用されます。</li>
        </ol>
      </LegalSection>

      <LegalSection heading="第2条 (定義)">
        <ol>
          <li>
            「グループ」とは、割り勘の計算単位として本サービス上に作成されるイベント
            (旅行・飲み会など) を指します。
          </li>
          <li>
            「共有リンク」とは、グループごとに発行される固有の URL を指します。会員登録をしなくても、
            この URL を知っている人はグループを利用できます。
          </li>
          <li>
            「アカウント」とは、メールアドレスに届く確認コードによって作成される任意の登録情報を
            指します。アカウントの作成は本サービスの利用条件ではありません。
          </li>
        </ol>
      </LegalSection>

      <LegalSection heading="第3条 (本サービスの位置づけ)">
        <ol>
          <li>
            本サービスは、金額の計算と記録を行うものであり、金銭の預託・送金・決済は一切行いません。
            実際の支払いは、利用者間で本サービスの外で行うものとします。
          </li>
          <li>
            本サービスが表示する精算プランは計算結果の提案であり、利用者間の債権債務を確定させる
            ものではありません。
          </li>
          <li>
            「送金しました」「受け取りました」の記録は、利用者の入力に基づくものです。当方は
            その記録が事実と一致することを保証しません。
          </li>
          <li>
            利用者間の金銭の授受に関する紛争は、利用者間で解決するものとし、当方は関与しません。
          </li>
        </ol>
      </LegalSection>

      <LegalSection heading="第4条 (利用開始)">
        <ol>
          <li>本サービスの利用は、利用者が本規約に同意したうえで、共有リンクにアクセスすることによって開始されます。</li>
        </ol>
      </LegalSection>

      <LegalSection heading="第5条 (共有リンクの取り扱い)">
        <ol>
          <li>
            共有リンクを知っている人は、会員登録やログインをしていなくても、そのグループの内容
            (メンバー・支出・金額・精算結果) を閲覧し、追加・変更・削除できます。
            本サービスは、共有リンクを知っていること自体を利用の資格として扱います。
          </li>
          <li>
            共有リンクをどこまで共有するかは、利用者の責任で管理してください。第三者に共有リンクが
            知られたことによって生じた損害について、当方は責任を負いません。
          </li>
        </ol>
      </LegalSection>

      <LegalSection heading="第6条 (アカウント)">
        <ol>
          <li>
            アカウントの認証はメールアドレスに送信する確認コードによって行います。パスワードは
            設定しません。
          </li>
          <li>
            確認コードが届くメールアドレスを管理できる方が、そのアカウントの利用者とみなされます。
            メールアドレスの管理は利用者の責任で行ってください。
          </li>
          <li>
            利用者が未成年者である場合は、親権者などの法定代理人の同意を得たうえで利用してください。
          </li>
        </ol>
      </LegalSection>

      <LegalSection heading="第7条 (禁止事項)">
        <p>利用者は、本サービスの利用にあたり、次の行為をしてはなりません。</p>
        <ol>
          <li>法令または公序良俗に違反する行為</li>
          <li>犯罪行為に関連する行為</li>
          <li>他の利用者や第三者の権利・利益を侵害する行為</li>
          <li>
            自らが関与していないグループの共有リンクを、不正な手段で取得または推測して利用する行為
          </li>
          <li>本サービスの運営を妨害する行為、サーバーに過大な負荷をかける行為</li>
          <li>本サービスを複製・改変して再配布する行為、および商用目的で再提供する行為</li>
          <li>その他、当方が不適切と判断する行為</li>
        </ol>
      </LegalSection>

      <LegalSection heading="第8条 (広告の掲載)">
        <p>
          本サービスは、運営費用をまかなうために広告を掲載する場合があります。広告の配信にあたっては
          Cookie や広告識別子が利用されることがあります。詳細は
          <a href="/privacy">プライバシーポリシー</a>
          をご確認ください。
        </p>
      </LegalSection>

      <LegalSection heading="第9条 (サービスの変更・中断・終了)">
        <ol>
          <li>
            当方は、利用者への事前の通知なく、本サービスの内容を変更し、または提供を中断・終了する
            ことができます。
          </li>
          <li>
            本サービスは無償で提供されます。変更・中断・終了によって利用者に生じた損害について、
            当方は責任を負いません。
          </li>
        </ol>
      </LegalSection>

      <LegalSection heading="第10条 (データの取り扱い)">
        <ol>
          <li>
            当方は、本サービスの提供のために必要な範囲で、利用者が入力したデータを保存します。
            取り扱いの詳細は<a href="/privacy">プライバシーポリシー</a>によります。
          </li>
          <li>
            当方は、データのバックアップを保証しません。データの消失に備え、必要な情報は利用者ご自身で
            控えを取ってください。
          </li>
          <li>
            長期間利用されていないグループのデータは、当方の判断で削除する場合があります。
          </li>
        </ol>
      </LegalSection>

      <LegalSection heading="第11条 (免責)">
        <ol>
          <li>
            本サービスは現状有姿で提供されます。当方は、本サービスが利用者の特定の目的に適合すること、
            期待する機能・正確性・有用性を有すること、および利用が中断されないことを保証しません。
          </li>
          <li>
            当方は、本サービスの利用によって利用者に生じた損害について、当方に故意または重大な過失が
            ある場合を除き、責任を負いません。
          </li>
          <li>
            前項にかかわらず、当方が責任を負う場合であっても、その範囲は現実に発生した通常の損害に
            限られます。
          </li>
        </ol>
      </LegalSection>

      <LegalSection heading="第12条 (知的財産権)">
        <p>
          本サービスを構成するプログラム・デザイン・文章などに関する知的財産権は、当方または正当な
          権利者に帰属します。利用者が入力したデータに関する権利は、利用者または正当な権利者に
          帰属します。
        </p>
      </LegalSection>

      <LegalSection heading="第13条 (本規約の変更)">
        <p>
          当方は、必要と判断した場合には、利用者に通知することなく本規約を変更できます。変更後の
          本規約は、本サービス上に掲載した時点から効力を生じます。変更後に本サービスを利用した場合、
          変更に同意したものとみなします。
        </p>
      </LegalSection>

      <LegalSection heading="第14条 (準拠法・裁判管轄)">
        <ol>
          <li>本規約の解釈にあたっては、日本法を準拠法とします。</li>
          <li>
            本サービスに関して紛争が生じた場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
          </li>
        </ol>
      </LegalSection>
    </LegalDocument>
  );
}
